export const ImportInvoicesGridPluginSettings: IPluginSettings = {
    name: 'Импорт накладных',
    mnemocode: 'import_invoices_plugin',
    permission: 'ImportInvoice',
    columns: []
}
